import { CertificationApiType, CertificationUserTestQuestionApiType } from '@api/types';
import { CertificationType, CertificationUserTestQuestionType } from '@types';

export const certificationsApiMapper = (
  certificationApi: CertificationApiType,
): CertificationType => {
  try {
    return {
      idCertification: certificationApi.idCertification,
      idCertificationUserTest: certificationApi.idCertificationUserTest,
      name: certificationApi.name,
      mark: certificationApi.mark,
      icon: certificationApi.icon,
      state: certificationApi.state,
      creationDate: certificationApi.creationDate,
      nbQuestions: certificationApi.nbQuestions,
      nbAttempts: certificationApi.nbAttempts,
      nbAttemptsMax: certificationApi.nbAttemptsMax,
    };
  } catch (e) {
    throw e;
  }
};

export const certificationUserTestQuestionsApiMapper = (
  certificationUserTestQuestionApi: CertificationUserTestQuestionApiType,
): CertificationUserTestQuestionType => {
  try {
    return {
      idCertificationUserTestQuestion:
        certificationUserTestQuestionApi.idCertificationUserTestQuestion,
      duration: certificationUserTestQuestionApi.duration,
      mark: certificationUserTestQuestionApi.mark,
    };
  } catch (e) {
    throw e;
  }
};
